export type IStepper = 20 | 40 | 60 | 80 | 100;

export enum LoginPageStep {
  LOGIN_TYPE = "login-type",
  LOGIN = "login",
  EMAIL_FORM = "email-form",
  TEMPORARY_FORM = "temporary-form",
  RE_ENTER_PASSWORD = "re-enter-password",
  SETUP_PIN = "setup-pin",
  NEW_PASSWORD = "new-password",
  SMS_MFA = "sms-mfa",
  SMS_MFA_LOGIN = "sms-mfa-login",
  LOGIN_SMS_MFA = "login-sms-mfa",
  LOGIN_CUSTOM_CHALLENGE = "login-custom-challenge",
  FORGOT_PASSWORD_SCREEN = "forgot-password-screen",
  RESET_PASSWORD_SCREEN = "reset-password-screen",
  PHONE_LOGIN = "phone-login",
  SMS_OTP_LOGIN = "sms-otp-login",
  IDENTIFIER = "identifier",
  SEND_CODE = "send-code",
  PASSWORD_ENTRY = "password-entry",
}

export enum SignupPageStep {
  SIGNUP_TYPE = "signup-type",
  SIGNUP_EMAIL_PASSWORD = "signup-email-password",
  SIGNUP_PCC = "signup-pcc",
  SMS_MFA = "sms-mfa",
  SETUP_PIN = "setup-pin",
}

export enum OnboardingPageStep {
  SUCCESS = "success",
  START = "start",
  EMAIL_FORM = "email-form",
  TEMPORARY_FORM = "temporary-form",
  RE_ENTER_PASSWORD = "re-enter-password",
  SETUP_PIN = "setup-pin",
  NEW_PASSWORD = "new-password",
  SMS_MFA = "sms-mfa",
}

export enum ChangePasswordStep {
  CURRENT_PASSWORD = "current-password",
  NEW_PASSWORD = "new-password",
  RE_ENTER_PASSWORD = "re-enter-password",
  SUCCESS_CHANGE_PASS = "success-change-password",
}

export enum ChangePinStep {
  CURRENT_PASSWORD = "current-password",
  NEW_PIN = "new-pin",
  CONFIRM_PIN = "confirm-pin",
  SUCCESS_CHANGE_PIN = "success-change-pin",
}
